module.exports = __webpack_public_path__ + "img/florian_detourne_2-lazy.2d3c7f19.jpg";